import { useEffect, useState } from 'react'

import api from '../../../../api/api'

export const useGetBuildingNumber = (buildingId) => {
  const [buildingPhoneNumberData, setBuildingPhoneNumberData] = useState({
    data: {},
    isLoading: false,
  })

  const fetchBuildingPhoneNumber = async (buildingId) => {
    if (buildingPhoneNumberData.isLoading) {
      return
    }

    setBuildingPhoneNumberData((prev) => ({ ...prev, isLoading: true }))

    try {
      const response = await api.getBuildingPhoneNumberByBuildingId(buildingId)

      setBuildingPhoneNumberData({ data: response, isLoading: false })
    } catch (error) {
      console.error('Error fetchBuildingPhoneNumber:', error)
      setBuildingPhoneNumberData((prev) => ({ ...prev, isLoading: false }))
    }
  }

  useEffect(() => {
    if (buildingId) {
      fetchBuildingPhoneNumber(buildingId)
    }
  }, [buildingId])

  return buildingPhoneNumberData
}
